import { useParams } from 'react-router'
import { FormWrapper } from '@/form-control'
import { TextAreaField, TextField } from '@/form-control/fields'
import TagField from '@/form-control/fields/TagField'
import ROUTES from '@/ROUTES'

import { IKnowledge } from '@/MODELS/knowledge.model'

import AdminPageHeader from '@/components/AdminPageHeader'
import Button from '@/components/Button'

export default function AdminKnowledgeForm(props: { id?: string }) {
    const params = useParams()
    const id = props?.id ?? params?.id ?? 'new'

    return (
        <>
            <AdminPageHeader heading={id !== 'new' ? 'Edit Knowledge' : 'Create New Knowledge'} />
            <FormWrapper<IKnowledge>
                endpoint={ROUTES.admin.knowledge}
                id={id}
                redirectAfterSubmit='/admin/knowledge-base'
                additionalSubmissionRowContent={
                    <div className='flex items-center justify-between w-full gap-x-2 h-fit'>
                        <Button.Back />
                    </div>
                }
            >
                {(f) => (
                    <div className='border rounded-xl mt-8'>
                        <section className='bg-white rounded-xl shadow-sm border-gray-200 overflow-hidden'>
                            <div className='px-6 py-3 space-y-3'>
                                <div className='grid lg:grid-cols-2 gap-6'>
                                    <TextField {...f('title')} label='Title' />
                                    <div className='lg:col-span-2'>
                                        <TextAreaField {...f('content')} label='Description' rows={5} />
                                    </div>
                                </div>
                            </div>

                            <div className='p-6 space-y-3'>
                                <div className='grid lg:grid-cols-2 gap-6'>
                                    <TextAreaField {...f('metadata')} containerClass='col-span-2' />
                                </div>
                            </div>
                        </section>
                    </div>
                )}
            </FormWrapper>
        </>
    )
}
